import styled, { css } from 'styled-components';
import { generateClassNames, applyDisplayNames } from '../../utils/functions';
import { InputSize } from '../../utils/types';
import { Color as PColor } from '../../utils/types/palette';
import { BorderRadiusSize as BRSize } from '../../utils/types/shape';
import { errorMixin, sizeTextAreaMixin } from './textarea.mixin';
import { getInputBackgroundColor, getInputTextColor, getInputBorderColor } from '../input/input.utils';
var baseClassName = 'Textarea';
var Textarea = /*#__PURE__*/styled.div.attrs({
  className: generateClassNames(baseClassName, 'root')
}).withConfig({
  componentId: "sc-1usif6k-0"
})(function (_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? InputSize.Md : _ref$size,
    _ref$error = _ref.error,
    error = _ref$error === void 0 ? false : _ref$error,
    _ref$fullWidth = _ref.fullWidth,
    fullWidth = _ref$fullWidth === void 0 ? false : _ref$fullWidth,
    _ref$readOnly = _ref.readOnly,
    readOnly = _ref$readOnly === void 0 ? false : _ref$readOnly,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$autoSize = _ref.autoSize,
    autoSize = _ref$autoSize === void 0 ? false : _ref$autoSize,
    theme = _ref.theme;
  return css(["position:relative;display:inline-flex;flex-direction:column;align-items:flex-end;justify-content:space-between;cursor:text;box-sizing:border-box;transition:all 100ms ease-out;width:", ";pointer-events:", ";background-color:", ";border-radius:", ";border:1px solid ", ";color:", ";", " ", " &:hover{color:", ";}", " ", ""], fullWidth ? '100%' : '300px', disabled ? 'none' : 'auto', getInputBackgroundColor(readOnly, disabled), theme.shape.borderRadius[BRSize.Md], getInputBorderColor(readOnly, disabled), disabled ? theme.palette[PColor.TextPlaceholder] : theme.palette[PColor.TextPrimary], sizeTextAreaMixin[size], !readOnly && !disabled && css(["&:focus-within{background-color:", "!important;border:1px solid ", ";&:hover{border:1px solid ", ";}}&:hover{background-color:", ";border:1px solid ", ";}"], theme.palette[PColor.BackgroundSecondary], theme.palette[PColor.AccentStateless], theme.palette[PColor.AccentStateless], theme.palette[PColor.BackgroundStateless], theme.palette[PColor.BordersPrimaryHover]), getInputTextColor(readOnly, disabled), error && errorMixin, autoSize && css(["width:auto;height:auto;"]));
});
var Base = /*#__PURE__*/styled.textarea.attrs({
  className: generateClassNames(baseClassName, 'Base')
}).withConfig({
  componentId: "sc-1usif6k-1"
})(function (_ref2) {
  var palette = _ref2.theme.palette;
  return css(["display:block;width:100%;height:100%;color:inherit;outline:none;resize:none;min-width:0;margin:0;padding:0;border:0;background-color:transparent;outline:none;font-size:inherit;line-height:inherit;color:inherit;font-weight:inherit;font-family:inherit;&::placeholder{color:", ";}"], palette[PColor.TextPlaceholder]);
});
var CopyIcon = /*#__PURE__*/styled.span.attrs({
  className: generateClassNames(baseClassName, 'CopyIcon')
}).withConfig({
  componentId: "sc-1usif6k-2"
})(function (_ref3) {
  var palette = _ref3.theme.palette;
  return css(["display:flex;color:", ";cursor:pointer;"], palette[PColor.IconsPrimary]);
});
var Styled = applyDisplayNames({
  Textarea: Textarea,
  CopyIcon: CopyIcon,
  Base: Base
});
export default Styled;